import type { LocalOrderRecord } from "../../lib/offline-sync/types";

export function getOrderStatusBadgeClass(status: string): string {
  switch (status) {
    case "OPEN":
      return "border-primary/30 bg-primary/10 text-primary";
    case "PAID":
      return "border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400";
    case "VOID":
      return "border-destructive/30 bg-destructive/10 text-destructive";
    case "REFUNDED":
    case "PARTIAL_REFUNDED":
      return "border-orange-500/30 bg-orange-500/10 text-orange-700 dark:text-orange-400";
    case "MERGED":
      return "border-violet-500/30 bg-violet-500/10 text-violet-700 dark:text-violet-400";
    default:
      return "border-border bg-muted text-muted-foreground";
  }
}

export function getOrderStatusLabel(status: string): string {
  switch (status) {
    case "OPEN":
      return "ເປີດ";
    case "PAID":
      return "ຊຳລະແລ້ວ";
    case "VOID":
      return "ຍົກເລີກ";
    case "REFUNDED":
      return "ຄືນເງິນ";
    case "PARTIAL_REFUNDED":
      return "ຄືນເງິນບາງສ່ວນ";
    case "MERGED":
      return "ລວມບິນ";
    default:
      return status;
  }
}

export function getOrderTypeLabel(orderType: string): string {
  switch (orderType) {
    case "DINE_IN":
      return "Dine In";
    case "TAKEAWAY":
      return "Take Away";
    case "DELIVERY":
      return "Delivery";
    default:
      return orderType;
  }
}

export function getSyncStatusLabel(
  status: LocalOrderRecord["syncStatus"],
): string {
  switch (status) {
    case "not_ready":
      return "Local only";
    case "queued":
      return "ລໍຖ້າ sync";
    case "syncing":
      return "ກຳລັງ sync";
    case "synced":
      return "sync ແລ້ວ";
    case "failed":
      return "sync failed";
    case "needs_review":
      return "needs review";
    default:
      return status;
  }
}

export function getSyncStatusBadgeClass(
  status: LocalOrderRecord["syncStatus"],
): string {
  switch (status) {
    case "queued":
      return "border-amber-500/30 bg-amber-500/10 text-amber-800 dark:text-amber-300";
    case "syncing":
      return "border-sky-500/30 bg-sky-500/10 text-sky-800 dark:text-sky-300";
    case "synced":
      return "border-emerald-500/30 bg-emerald-500/10 text-emerald-800 dark:text-emerald-300";
    case "failed":
    case "needs_review":
      return "border-destructive/30 bg-destructive/10 text-destructive";
    default:
      return "border-border bg-muted/50 text-muted-foreground";
  }
}
